import { useNextSanityImage } from 'next-sanity-image';
import Img from 'next/image';
import sanityClient from './sanityClient';

interface Props {
  source: {
    _type: string;
    assert: {
      _ref: string;
      _type: string;
    };
  };
}

export const SanityImage = ({ source }: Props) => {
  const imageProps = useNextSanityImage(sanityClient, source);
  return <Img {...imageProps} layout="responsive" sizes="(max-width: 65ch)" />;
};
